"use strict";
const validationOptions = require('./validationOptions');
/**
 * Helper wrapper for schema validators
 * Returns YUP errors, but adds generic message as first error
 */
exports.createValidator = (schema, message) => (data) => {
    try {
        schema.validateSync(data, validationOptions);
        return null;
    }
    catch (err) {
        if (err.name === 'ValidationError') {
            return [message, ...err.errors];
        }
        throw err;
    }
};
//# sourceMappingURL=createValidator.js.map